var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 6H21C21.55 6 22 6.45 22 7C22 7.55 21.55 8 21 8H20V19C20 20.654 18.654 22 17 22H7C5.346 22 4 20.654 4 19V8H3C2.45 8 2 7.55 2 7C2 6.45 2.45 6 3 6H4H8V4.328C8 3.044 9.121 2 10.5 2H13.5C14.879 2 16 3.044 16 4.328V6H20ZM10 4.328C10 4.173 10.214 4 10.5 4H13.5C13.786 4 14 4.173 14 4.328V6H10V4.328ZM17 20C17.552 20 18 19.551 18 19V8H6V19C6 19.551 6.448 20 7 20H17ZM9 17C9.55 17 10 16.55 10 16V12C10 11.45 9.55 11 9 11C8.45 11 8 11.45 8 12V16C8 16.55 8.45 17 9 17ZM15 17C15.55 17 16 16.55 16 16V12C16 11.45 15.55 11 15 11C14.45 11 14 11.45 14 12V16C14 16.55 14.45 17 15 17Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12594_108868",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 6H21C21.55 6 22 6.45 22 7C22 7.55 21.55 8 21 8H20V19C20 20.654 18.654 22 17 22H7C5.346 22 4 20.654 4 19V8H3C2.45 8 2 7.55 2 7C2 6.45 2.45 6 3 6H4H8V4.328C8 3.044 9.121 2 10.5 2H13.5C14.879 2 16 3.044 16 4.328V6H20ZM10 4.328C10 4.173 10.214 4 10.5 4H13.5C13.786 4 14 4.173 14 4.328V6H10V4.328ZM17 20C17.552 20 18 19.551 18 19V8H6V19C6 19.551 6.448 20 7 20H17ZM9 17C9.55 17 10 16.55 10 16V12C10 11.45 9.55 11 9 11C8.45 11 8 11.45 8 12V16C8 16.55 8.45 17 9 17ZM15 17C15.55 17 16 16.55 16 16V12C16 11.45 15.55 11 15 11C14.45 11 14 11.45 14 12V16C14 16.55 14.45 17 15 17Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12594_108868)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteTrash);
export default __webpack_public_path__ + "static/media/delete-trash.586b929c2b98d16870fc1609d67a3cca.svg";
export { ForwardRef as ReactComponent };